import React from "react";
import { useState } from "react";
import axios from "axios";
import Hubnav from "../Hubnav";
import toastify from "../../Util/toastify";
import BaseURL from "../../Util/BaseURL";
const AddDeliveryBoy = () => {
  const [DeliveryBoy, setDeliveryBoy] = useState();
  const [name, setName] = useState();
  const [aadharNumber, setAadharNumber] = useState();
  const [phNumber, setPhNumber] = useState();
  const [email, setEmail] = useState();
  const [address, setAddress] = useState();
  const [userPassword, setUserPassword] = useState();
  const [pincode, setPincode] = useState();

  async function getDeliveryBoy() {
    const response = await axios.get(
      `${BaseURL}FindByName?name=${DeliveryBoy}`
    );
    return response;
  }
  async function add() {
    var s = await getDeliveryBoy();
    if (s.data.length > 0) {
      toastify("DeliveryBoy UserName already exists", "error");
      setDeliveryBoy("");
      s = [];
    } else {
      axios.post(
        `${BaseURL}AddDeliveryBoy`,
        {
          deliveryBoyId: DeliveryBoy,
          name,
          aadharNumber,
          phNumber,
          email,
          address,
          deliverypincode: pincode,
          hubname: sessionStorage.getItem("user"),
        },
        {
          headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") },
        }
      );
      axios.post(
        `${BaseURL}registerNewDeliveryBoy`,
        {
          email,
          name,
          userName: DeliveryBoy,
          userPassword,
        },
        {
          headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") },
        }
      );
      toastify("Delivery Boy Added Successfully", "success");
      setDeliveryBoy("");
      setName("");
      setAadharNumber("");
      setPhNumber("");
      setEmail("");
      setAddress("");
      setName("");
      setUserPassword("");
      setPincode("");
    }
  }
  return (
    <>
      <Hubnav />
      <section id="hero">
        <div className="hero-container">
          <div className="hero-logo row">
            <h1 className="font-weight-bold col">Add Delivery Boy</h1>
          </div>
        </div>
      </section>
      <div className="form-container" id="mainform">
        <form action="" className="checkout-form">
          <div className="input-line">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Name of the Delivery Boy"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="AdhaarNumber">Adhaar Number</label>
            <input
              type="number"
              name="AdhaarNumber"
              id="AdhaarNumber"
              placeholder="Adhaar Number of the Delivery Boy"
              value={aadharNumber}
              onChange={(e) => setAadharNumber(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="phonenumber">Phone Number</label>
            <input
              type="number"
              name="phonenumber"
              id="phonenumber"
              placeholder="Contact Number of the Delivery Boy"
              value={phNumber}
              onChange={(e) => setPhNumber(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="email">Email</label>
            <input
              type="text"
              name="email"
              id="email"
              placeholder="Email of the Delivery Boy"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="address">Address</label>
            <input
              type="text"
              name="address"
              id="address"
              placeholder="Address of the Delivery Boy"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
          <div className="input-line">
            <label htmlFor="Delivery Pincode">Delivery Area Pincode</label>
            <input
              type="text"
              name="pincode"
              id="pincode"
              placeholder="Delivery Area Pincode"
              value={pincode}
              onChange={(e) => setPincode(e.target.value)}
            />
          </div>
          <div className="input-container">
            <div className="input-line">
              <label htmlFor="userName">Username</label>
              <input
                type="text"
                name="userName"
                id="userName"
                placeholder="User Name for the Delivery Boy"
                value={DeliveryBoy}
                onChange={(e) => setDeliveryBoy(e.target.value)}
              />
            </div>
            <div className="input-line">
              <label htmlFor="password">Password</label>
              <input
                type="text"
                name="password"
                id="password"
                placeholder="Password for the Delivery Boy"
                value={userPassword}
                onChange={(e) => setUserPassword(e.target.value)}
              />
            </div>
          </div>
          <div style={{ paddingBottom: "50px", paddingTop: "10px" }}>
            <div className="addseller">
              <button
                type="button"
                className="btn btn-success addsellerbtn"
                onClick={() => add()}
              >
                Add Delivery Boy
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddDeliveryBoy;
